/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React from 'react';
import useAxios from "./useAxios";

const UseAccessToken = () => {

    const _axios = useAxios();

    const reactUser = `${process.env.REACT_APP_TOKEN_USERNAME}`;
    const reactPass = `${process.env.REACT_APP_TOKEN_PASSWORD}`;

    const refresh = async () =>{
        try {
            const res = await _axios.post('api/getaccesstoken', { email: reactUser, password: reactPass });
            localStorage.setItem('accessToken', JSON.stringify(res.data.authorization));
            return res.data.authorization;
        }catch (err){
            return null;
        }



    }
    return refresh;

};

export default UseAccessToken;
